/**
 * @file 微视 common 模块入口，和业务相关的一些模块
 */
import pageInfo from './pageInfo';
import pageVisiable from './pageVisiable';
import ui from './ui';
import util from './util';

export {
  pageInfo,
  pageVisiable,
  ui,
  util,
};

export default {
  pageInfo,
  pageVisiable,
  ui,
  util,
};
